import {SCREENS, NOT_IN_USE, BASED_ON} from '../Redux/NavigationRedux'
import routeNames from './routeNames'

const MOBILE_NAV = []
MOBILE_NAV.push({
	screen: SCREENS.INIT,
	path: NOT_IN_USE,
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.LIABILITY_DETAIL,
	path: '/',
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.PROPERTY,
	path: routeNames.propertyHousehold,
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.HOUSEHOLD,
	path: routeNames.propertyHousehold,
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.LIABILITY,
	path: NOT_IN_USE,
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.PROPERTY_TYPE,
	path: routeNames.propertyDetail,
	exact: true,
	basedOn: BASED_ON.PROPERTY_ACTIVE,
})
MOBILE_NAV.push({
	screen: SCREENS.HOUSEHOLD_DETAIL,
	path: routeNames.householdDetail,
	exact: true,
	basedOn: BASED_ON.HOUSEHOLD_ACTIVE,
})
MOBILE_NAV.push({
	screen: SCREENS.CUSTOMER_FORM,
	path: routeNames.customerForm,
	exact: true
})
MOBILE_NAV.push({
	screen: SCREENS.FINAL,
	path: routeNames.final,
	exact: true
})

export default MOBILE_NAV
